import { FeatureFlag, Toggl } from '../../shared/utils/togglz';

export type TogglzState = Partial<Record<FeatureFlag, Toggl>> | undefined;

export enum TogglzActionType {
    SET_TOGGLZ = 'SET_TOGGLZ'
}

export type SetTogglzAction = {
    type: TogglzActionType.SET_TOGGLZ;
    payload: ReadonlyArray<Toggl>;
};

export const togglzReducer = (state: TogglzState, action: SetTogglzAction): TogglzState => {
    switch (action.type) {
        case TogglzActionType.SET_TOGGLZ:
            const togglzData = action.payload.reduce((acc, toggle) => {
                acc[toggle.name] = { ...toggle };
                return acc;
            }, {});
            return { ...togglzData };
        default:
            return state;
    }
};

export const initialTogglzState: TogglzState = undefined;
